import * as React from "react";
import { IBulkUsageIpAdjustmentIP } from "../../../../types/usageTypes/IBulkUsageIpAdjustmentRequest";

export interface IBulkUsageAdjustmentConfirmViewProps {
    selectedGroupCount: number;
    fromIP: IBulkUsageIpAdjustmentIP;
    toIP: IBulkUsageIpAdjustmentIP;
    onCancel: () => void;
    onConfirm: () => void;
}

const BulkUsageAdjustmentConfirmView: React.FC<IBulkUsageAdjustmentConfirmViewProps> = ({ selectedGroupCount, fromIP, toIP, onCancel, onConfirm }) => (
    <div className="bulkAdjustmentConfirmView">
        <p>
            Submit a job for {selectedGroupCount} selected Usage{" "}
            {selectedGroupCount === 1 ? "Group" : "Groups"}?
        </p>

        <div className="bulkAdjustmentConfirmIPs">
            <div>
                <span>From IP</span>
                <strong>{fromIP.name}</strong>
                <span>IPI Number: {fromIP.ipiNumber}</span>
                <span>Account Number: {fromIP.accountNumber || "Not available"}</span>
            </div>
            <div>
                <span>To IP</span>
                <strong>{toIP.name}</strong>
                <span>IPI Number: {toIP.ipiNumber}</span>
                <span>Account Number: {toIP.accountNumber || "Not available"}</span>
            </div>
        </div>

        <h2>What this job will do</h2>
        <ul>
            <li>
                Adjust matching Usage Details only when Amount is non-zero.
                Positive and negative amounts qualify.
            </li>
            <li>Skip Usage Groups with an Allocated allocation.</li>
            <li>Replace existing adjustments on eligible details.</li>
            <li>Leave groups with no eligible details unchanged.</li>
        </ul>

        <div className="bulkAdjustmentConfirmActions">
            <button
                type="button"
                className="button btn-defaultSecondary noMargin"
                onClick={onCancel}
            >
                Cancel
            </button>
            <button
                type="button"
                className="button btn-defaultPrimary noMargin"
                onClick={onConfirm}
            >
                Submit Job
            </button>
        </div>
    </div>
);

export default BulkUsageAdjustmentConfirmView;